import * as iUtil from 'smart-core-util'

import "babel-polyfill"
import Vue from 'vue'
import App from './App'
import router from './router'

import './assets/css/public.css';
import './assets/css/svg.css';
import api from './api/api';
import http from './api/getData';
import reg from './api/reg';

import Mint from 'mint-ui';
import 'mint-ui/lib/style.css';

Vue.use(Mint);

import iJsBridge from 'smart-javascript-bridge'

Vue.config.productionTip = false;
Vue.prototype.$api = api;
Vue.prototype.$http = http;
Vue.prototype.$reg = reg;
Vue.prototype.$smartBridge = new iJsBridge({alert: Mint.Toast});
Vue.prototype.iStorage = iUtil.iStorage

iUtil.iStorage.install({ debug: false }).then(() => {
  iUtil.iHttp.api.defaults.baseURL = iUtil.iStorage.getUrlGateway();
  new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: { App }
  })

})



// WEBPACK FOOTER //
// ./src/main.js